import DocumentItem from './DocumentItem'

export default class BasicText extends DocumentItem {
    constructor() {
        super()
        this.instruction = ''
    }
}
